module.exports = __webpack_public_path__ + "img/icon3.d8972513.svg";